import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";

import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import axios from "axios";
import { toast } from "react-hot-toast";

import AvatarForm from "../forms/AvatarForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Avatar = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const [avatarLoading, setAvatarLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const baseUrl = process.env.REACT_APP_API_URL;

  const { setActiveMainPageNav } = useStateContext();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitHandlerParent = async (formData) => {
    const { token } = JSON.parse(localStorage.getItem("user"));
    const path = `/api/user/createAvatarBlock`;
    const url = baseUrl + path;

    console.log(formData, "parent submission");
    setAvatarLoading(true);
    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `'Bearer ' ${token}`,
        },
      });
      const status = response?.data?.status;
      const message = response?.data?.message;

      if (status === "success") {
        toast.success("Avatar Uploaded Successfully");

        navigate("/dashboard");
      }
      if (status === "failed") {
        toast.error(message);
      }
    } catch (error) {
      console.log(error, "avatar error");
      toast.error("Something went wrong ");
    }

    setAvatarLoading(false);

    fetchingLinksList();
  };

  const fetchingLinksList = () => {
    // data need for fetching link list
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    if (linkId) {
      dispatch(gettingLinkList(linkListData));
    }
  };

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("avatar")} </p>
          </div>
        </Link>
      </div>

      <AvatarForm
        formType={"add"}
        submitHandlerParent={submitHandlerParent}
        avatarLoading={avatarLoading}
      />
    </>
  );
};

export default Avatar;
